// format.js — the one place numbers, dates and durations are formatted for
// charts, Progress, Home and the calendar, so "3,150" never sits beside "3150"
// and a date reads "Aug 11" everywhere (never "8/11").

const DAY = 86400000;

// 3150 → "3,150"; 12.25 → "12.3" with dec=1.
export function fmtNum(v, dec = 0) {
  if (v == null || !isFinite(v)) return '';
  return Number(v).toLocaleString(undefined, { maximumFractionDigits: dec, minimumFractionDigits: 0 });
}

// Compact for tight spaces: 950 → "950", 3150 → "3.2k", 38240 → "38.2k", 382400 → "382k", 1.25e6 → "1.3M".
export function fmtCompact(v) {
  if (v == null || !isFinite(v)) return '';
  const a = Math.abs(v);
  if (a >= 1e6) return (v / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
  if (a >= 1e5) return Math.round(v / 1000) + 'k';
  if (a >= 1000) return (v / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  return fmtNum(Math.round(v * 10) / 10, 1);
}

// "Aug 11" — the short date for axes, tooltips and meta lines.
export function fmtShortDate(ms) {
  return new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
// "Aug 11, 2025" when not this year, else "Aug 11".
export function fmtDate(ms, now = Date.now()) {
  const d = new Date(ms);
  return d.getFullYear() === new Date(now).getFullYear() ? fmtShortDate(ms)
    : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
export function fmtMonthYear(ms) {
  return new Date(ms).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
}

// Relative day: "Today", "Yesterday", "3d ago", "2w ago", then a date.
export function fmtRelative(ms, now = Date.now()) {
  const d0 = new Date(now); d0.setHours(0, 0, 0, 0);
  const d1 = new Date(ms); d1.setHours(0, 0, 0, 0);
  const days = Math.round((d0 - d1) / DAY);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days}d ago`;
  if (days < 35) return `${Math.floor(days / 7)}w ago`;
  const d = new Date(ms);
  return d.getFullYear() === new Date(now).getFullYear() ? fmtShortDate(ms)
    : d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
}

// Workout duration: "<1 min", "48 min", "1 h 12 min".
export function fmtMinutes(ms) {
  const m = Math.round(ms / 60000);
  if (m < 1) return '<1 min';
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h${m % 60 ? ` ${m % 60} min` : ''}`;
}
